/** The tier a state acts as for the visibility and messaging matrix. */
export function tierOf(state) {
    switch (state) {
        case 'anonymous':
            return 'anonymous';
        case 'pending':
            return 'pending';
        case 'trusted':
        case 'restricted':
            return 'trusted';
        default:
            return null;
    }
}
//# sourceMappingURL=tier-of.js.map